import React from 'react';

const CsvFileChip = ({ file, onRemove }) => {
  return (
    <div className="csv-file-display">
      <img src="/images/icon/csv.svg" alt="table icon" className="csv-icon" />
      <span className="csv-file-name">{file?.name}</span>
      <img
        className="remove"
        src="/images/icon/close.svg"
        alt="remove"
        onClick={onRemove}
      />
    </div>
  );
};

export default CsvFileChip;
